(function () {
  var SKIP_SECTION =
    '.b2b-hero, .b2b-pdp-sticky-bar, [data-b2b-journey], [data-b2b-reveal-off]';

  var LIST_ITEM_PARENT =
    '[class*="__list"], [class*="__grid"], [class*="__cards"], [class*="__steps"], ' +
    '[class*="__rows"], [class*="__charts"], [class*="__filters"], [class*="__stats"], ' +
    '[class*="__pills"], [class*="__chips"], [class*="__logos"], [class*="__inline-stats"], ' +
    '[class*="__capabilities"], [class*="__applications"], [class*="__milestones"], [class*="__features"], ' +
    '[class*="__team"], [class*="__awards"], [class*="__connect"], [class*="__devices"], [class*="__tools"], ' +
    '[class*="__hardware"], [class*="__services"], [class*="__packages"], [class*="__benefits"], ' +
    '[class*="__pricing"], [class*="__compare"], [class*="__proof"], [class*="__faq"], [class*="__search-results"]';

  var TEXT_STACK =
    '[class*="__header"], [class*="__intro"], [class*="__copy"], [class*="__content"], ' +
    '[class*="__main"] > [class*="__intro"]';

  var BLOCK_REVEAL =
    '[class*="__purchase"], [class*="__table-wrap"], [class*="__table"], [class*="__showcase"], ' +
    '[class*="__outro"], [class*="__split"]';

  var MAX_DELAY_MS = 160;
  var revealObserver = null;
  var scrollPending = false;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function capDelay(delay) {
    if (typeof delay === 'number') {
      return Math.min(delay, MAX_DELAY_MS) + 'ms';
    }

    var value = parseFloat(delay);
    if (isNaN(value)) return delay;

    if (String(delay).indexOf('s') !== -1) {
      value = value * 1000;
    }

    return Math.min(value, MAX_DELAY_MS) + 'ms';
  }

  function stagger(index, step, base) {
    return capDelay(index * step + base);
  }

  function isContainer(el) {
    if (!el || !el.className) return false;
    return /__(list|grid|cards|steps|charts|rows|stats|pills|filters|chips|form|timeline|viewport|scroll|inner|content|stack|main|panel|table|toolbar|faq|accordion)/.test(
      el.className
    );
  }

  function isInViewport(el) {
    var rect = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return rect.top < vh * 0.98 && rect.bottom > vh * 0.02;
  }

  function markReveal(el, delay, media) {
    if (!el || el.classList.contains('b2b-reveal') || el.classList.contains('b2b-hero__reveal')) {
      return;
    }

    el.classList.add('b2b-reveal');
    if (media) el.classList.add('b2b-reveal--media');
    el.style.setProperty('--b2b-reveal-delay', capDelay(delay));

    if (isInViewport(el)) {
      el.classList.add('is-revealed');
    }
  }

  function autoPrepareSection(section) {
    section.querySelectorAll(
      'img[class*="__bg-img"], img[class*="__bg-image"], img[class*="__card-bg-img"], img[class*="__media-img"]'
    ).forEach(function (el) {
      markReveal(el, '0ms', true);
    });

    section.querySelectorAll(TEXT_STACK).forEach(function (group) {
      Array.from(group.children).forEach(function (child, index) {
        if (isContainer(child)) return;
        markReveal(child, stagger(index, 35, 40));
      });
    });

    section.querySelectorAll(LIST_ITEM_PARENT).forEach(function (list) {
      Array.from(list.children).forEach(function (child, index) {
        markReveal(child, stagger(index, 35, 60));
      });
    });

    section.querySelectorAll(
      '[class*="__card"]:not(.b2b-reveal), [class*="__chart"]:not(.b2b-reveal), ' +
        '[class*="__panel"]:not(.b2b-reveal), [class*="__figure"]:not(.b2b-reveal)'
    ).forEach(function (el, index) {
      if (el.closest(LIST_ITEM_PARENT)) return;
      markReveal(el, stagger(index, 40, 80));
    });

    section.querySelectorAll('[class*="__media"]:not(.b2b-reveal)').forEach(function (el, index) {
      if (el.matches('img')) return;
      if (el.querySelector(LIST_ITEM_PARENT)) return;
      markReveal(el, stagger(index, 35, 60));
    });

    section.querySelectorAll(BLOCK_REVEAL).forEach(function (el, index) {
      if (el.classList.contains('b2b-reveal')) return;
      if (el.matches('[class*="__table"]') && el.closest('[class*="__table-wrap"]')) return;
      markReveal(el, stagger(index, 35, 60));
    });

    section.querySelectorAll('[class*="__cta"]:not(.b2b-reveal), [class*="__footer"]:not(.b2b-reveal)').forEach(
      function (el) {
        markReveal(el, '120ms');
      }
    );

    section.querySelectorAll('[class*="__aside"]:not(.b2b-reveal)').forEach(function (el) {
      markReveal(el, '100ms');
    });

    section.querySelectorAll('form.b2b-contact__form:not(.b2b-reveal), form.b2b-cta-bar__form:not(.b2b-reveal)').forEach(
      function (el) {
        markReveal(el, '80ms');
      }
    );
  }

  function autoPrepare() {
    document.querySelectorAll('.b2b-scope.b2b-section').forEach(function (section) {
      if (section.matches(SKIP_SECTION)) return;
      autoPrepareSection(section);
    });
  }

  function revealAll(nodes) {
    nodes.forEach(function (el) {
      el.classList.add('is-revealed');
      if (revealObserver) revealObserver.unobserve(el);
    });
  }

  function revealVisibleUnrevealed() {
    document.querySelectorAll('.b2b-reveal:not(.is-revealed)').forEach(function (el) {
      if (!isInViewport(el)) return;
      el.classList.add('is-revealed');
      if (revealObserver) revealObserver.unobserve(el);
    });
  }

  function onScrollReveal() {
    if (scrollPending) return;
    scrollPending = true;
    requestAnimationFrame(function () {
      revealVisibleUnrevealed();
      scrollPending = false;
    });
  }

  function capExistingDelays() {
    document.querySelectorAll('.b2b-reveal').forEach(function (el) {
      var delay =
        el.style.getPropertyValue('--b2b-reveal-delay') ||
        getComputedStyle(el).getPropertyValue('--b2b-reveal-delay');

      if (delay) {
        el.style.setProperty('--b2b-reveal-delay', capDelay(delay.trim()));
      }
    });
  }

  function initReveal() {
    autoPrepare();
    capExistingDelays();

    var targets = document.querySelectorAll('.b2b-reveal:not(.is-revealed)');
    if (!targets.length) return;

    if (prefersReducedMotion() || typeof IntersectionObserver === 'undefined') {
      revealAll(targets);
      return;
    }

    revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          revealObserver.unobserve(entry.target);
        });
      },
      { root: null, threshold: 0, rootMargin: '0px 0px 12% 0px' }
    );

    targets.forEach(function (el) {
      revealObserver.observe(el);
    });

    revealVisibleUnrevealed();

    if (!window.__b2bRevealScrollBound) {
      window.__b2bRevealScrollBound = true;
      window.addEventListener('scroll', onScrollReveal, { passive: true });
      window.addEventListener('resize', onScrollReveal, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }

  document.addEventListener('shopify:section:load', initReveal);
})();
